import { useEffect, useState } from "react";

function CreateMeeting({ onCreated }) {
    const [participants, setParticipants] = useState([]);
    const [description, setDescription] = useState("");
    const [date, setDate] = useState("");

    const [search, setSearch] = useState("");
    const [users, setUsers] = useState([]);

    useEffect(() => {
        fetchUsers();
    }, []);

    const fetchUsers = async () => {
        const token = sessionStorage.getItem("token");

        const req = await fetch(`${process.env.REACT_APP_API_URL}/users/get`, {
            headers: { Authorization: `Bearer ${token}` }
        });

        const res = await req.json();
        setUsers(res);
    };

    const filteredUsers = users.filter(user => {
        const s = search.toLowerCase();

        return (
            user.lastName?.toLowerCase().includes(s) ||
            user.firstName?.toLowerCase().includes(s) ||
            user.profession?.toLowerCase().includes(s) ||
            user.mainLocation?.toLowerCase().includes(s)
        );
    });

    const toggleParticipant = (userId) => {
        if (participants.includes(userId)) {
            setParticipants(participants.filter(id => id !== userId));
        } else {
            setParticipants([...participants, userId]);
        }
    };

    const createMeeting = async () => {
        const token = sessionStorage.getItem("token");

        const [d, t] = date.split("T");
        const [year, month, day] = d.split("-").map(Number);
        const [hour, minute] = t.split(":").map(Number);

        const localDate = new Date(year, month - 1, day, hour, minute);

        const res = await fetch(`${process.env.REACT_APP_API_URL}/meeting/create`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify({
                participants,
                description,
                scheduledAt: localDate.toISOString()
            })
        });

        if (res.status === 201) {
            setParticipants([]);
            setDescription("");
            setDate("");
            onCreated();
        }
    };

    return (
        <div className="block">
            <h2>Créer une réunion</h2>

            <div className="inp_field">
                <label>Date</label>
                <input
                    type="datetime-local"
                    value={date}
                    onChange={e => setDate(e.target.value)}
                />
            </div>

            <div className="inp_field">
                <label>Description</label>
                <input
                    placeholder="Motif de la réunion"
                    value={description}
                    onChange={e => setDescription(e.target.value)}
                />
                <span className="exemple">Ne pas mettre de nom de patient (ex: "Besoin de parler RF trouble psy" ou "Enfant LH violence familiale possible").</span>
            </div>

            <div className="inp_field">
                <label>Rechercher des participants</label>
                <input
                    placeholder="Nom, prénom..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                />
            </div>

            <ul className="list_users">
                {filteredUsers.map(user => {
                    const isSelected = participants.includes(user._id);

                    return (
                        <li
                            key={user._id}
                            className={isSelected ? "selected" : ""}
                            onClick={() => toggleParticipant(user._id)}
                        >
                            <p><span>{user.profession}</span></p>
                            <p>{user.lastName} {user.firstName}</p>
                            <p>{user.mainLocation}</p>
                        </li>
                    );
                })}
            </ul>

            {participants.length > 0 && (
                <div className="list_block">
                    <label>Participants sélectionnés</label>
                    <ul>
                        {participants.map(id => {
                            const user = users.find(u => u._id === id);
                            if (!user) return null;

                            return (
                                <li key={id}>
                                    <button
                                        className="participant_tag"
                                        onClick={() => toggleParticipant(id)}
                                    >
                                        <span className="name">
                                            {user.lastName} {user.firstName}
                                        </span>
                                        <span className="remove">✕</span>
                                    </button>
                                </li>
                            );
                        })}
                    </ul>
                </div>
            )}

            <button className="btn_create" onClick={createMeeting}>
                Créer
            </button>
        </div>
    );
}

export default CreateMeeting;